module.exports = {
    "collectionLabel": `Ieteikumi`
};


//# sourceMappingURL=lv-LV.main.js.map
